export default __webpack_public_path__ + "static/media/temp_5.e6d3e45c.png";